import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row
} from "reactstrap";
import { appUrl } from '../../config';
import { DialogTitle, Dialog, DialogActions } from '@material-ui/core';

var md5 = require('md5');

// core components

class SignUp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      user: '',
      password: '',
      firstFocus: false,
      lastFocus: false,
      msgdiag: "",
      open: false,
      redirect:false
    }
  }
  componentDidMount() {
    const { token } = this.props.match.params
    console.log("token", token)
    fetch(appUrl + '/changepass/' + token, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {

        if (data.success) {
          this.setState({ open: true, msgdiag: data.message, usermail: data.mail })
        } else {
          this.setState({ open: true, msgdiag: data.message, redirect:true })

        }
      });
  }


  handleClickOpen = (msgdiag) => {
    this.setState({ open: true, msgdiag: msgdiag });
  }

  handleClose = () => {
    this.setState({ open: false, msgdiag: "" });
    if(this.state.redirect){
      this.props.history.push(`/`)
      this.setState({redirect:false })
    }
  }

  handleChangetype = name => event => {
    console.log("name", event.target.value)
    this.setState({ [name]: event.target.value });
    console.log(this.state)
  };
  handleSave = () => {
    if (this.state.password == this.state.repassword) {
      var pass = md5(this.state.password)
      fetch(appUrl + '/savechangepass', {
        method: 'post',
        body: JSON.stringify({
          mail: this.state.usermail,
          password: pass,
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            console.log(data)
            if (data.success) {
              console.log(data)
              this.setState({ open: true, msgdiag: data.message, redirect:true })

            } else {
              this.setState({ open: true, msgdiag: data.message })
            }
          } else {
            this.setState({ open: true, msgdiag: data.message })
          }
        });
    } else {
      this.setState({ open: true, msgdiag: "Las contraseñas no coinciden. Intente nuevamente. " })
    }
  };
  render() {

    return (
      <>
        <div
          className="section section-signup"
          style={{
            backgroundImage: "url(" + require("assets/img/header.jpg") + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center",
            minHeight: "730px",
          }}
        >
          <Container>
            <Row>
              <Card className="card-signup" data-background-color="blue">
                <Form action="" className="form" method="">
                  <CardHeader className="text-center">
                    <CardTitle tag="h3">
                      Cambiar contraseña
                  </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <InputGroup
                      className={
                        "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons text_caps-small"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Nueva contraseña..."
                        type="password"
                        value={this.state.password}
                        onFocus={() => this.setState({ firstFocus: true })}
                        onBlur={() => this.setState({ firstFocus: false })}
                        onChange={this.handleChangetype('password')}
                      ></Input>
                    </InputGroup>
                    <InputGroup
                      className={
                        "no-border" + (this.state.lastFocus ? " input-group-focus" : "")
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons text_caps-small"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Repetir nueva contraseña..."
                        type="password"
                        value={this.state.repassword}
                        onFocus={() => this.setState({ lastFocus: true })}
                        onBlur={() => this.setState({ lastFocus: false })}
                        onChange={this.handleChangetype('repassword')}
                      ></Input>
                    </InputGroup>

                  </CardBody>
                  <CardFooter className="text-center">
                    {

                    }
                    <Button
                      className="btn-neutral btn-round"
                      color="info"
                      href="#pablo"
                      onClick={this.handleSave}
                      size="lg"
                    >
                      Guardar
                  </Button>
                  </CardFooter>
                </Form>
              </Card>
            </Row>
            <div className="col text-center">
              <Button
                className="btn-round btn-white"
                color="default"
                to="/"
                outline
                size="lg"
                tag={Link}
              >
                Página inicial
            </Button>
            </div>
          </Container>
          <div>
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{this.state.msgdiag}</DialogTitle>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary" autoFocus>
                  Ok!
                   </Button>
              </DialogActions>
            </Dialog>

          </div>
        </div>
      </>
    );
  }
}
export default SignUp;